/**
 * ママンの予約可能性を表す定数
 */
const Availability = {
	/** @type {string} 予約可能 */
	available: 'available',
	/** @type {string} 他の予約なし */
	possible: 'possible',
	/** @type {string} 予約不可 */
	not: 'not'
}

export default Availability
